export const selectDate = state => state.date.date;